import { render, staticRenderFns } from "./ProjectTypicalFloorPlanDetails.vue?vue&type=template&id=3bda4ad7"
import script from "./ProjectTypicalFloorPlanDetails.vue?vue&type=script&lang=js"
export * from "./ProjectTypicalFloorPlanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports